import { Box } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React, { ReactNode } from "react";

export default ({
  show,
  onClick,
  children
}: {
  show: Boolean;
  onClick?: () => void;
  children?: ReactNode;
}) =>
  show ? (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "fixed",
          zIndex: 100,
          left: 0,
          top: 0,
          backgroundColor: "rgba(255, 255, 255, 0.75)"
        }}
        onClick={onClick}
        role="presentation"
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 300
        }}
      >
        {children}
      </Box>
    </>
  ) : (
    <>{children}</>
  );
